import { ProjectionGroup } from '../models/ProjectionGroupEnum';

// `AHEAD` is no longer surfaced as its own status: students projected to complete
// their whole Roadmap are reported together with On Track (75% or more). The backend
// still returns `AHEAD`, so the statuses are unified as the data enters the UI.
export const normalizeProjectionGroup = (status: string | null | undefined): ProjectionGroup | null => {
  if (!status) return null;

  return status === ProjectionGroup.AHEAD ? ProjectionGroup.ON_TRACK : (status as ProjectionGroup);
};
